export const ACCOUNT_PROFILE_DISPLAY_NAME_FALLBACK = "Unknown User";
